export default __webpack_public_path__ + "static/media/Group59.fa24fa2b.svg";